import React, { Component } from 'react'

// subComponent
import ListObjects from './list_objects'
import HeadBar from './headbar'
import ModalConfirmDelete from './modal_confirm_delete'
import ModalObjectInfo from './modal_objects_info'
import Paginate from './paginate'
import { Button, Empty } from 'antd'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/object/actions'
import ModalExportObject from './modal_ExportObject'

class ObjectsScreen extends Component {
    componentDidMount() {
        this.props.loadListObject({ page_number: 1, page_size: 12, status: 0 })

        if (this.props.match.params.id) {
            this.props.showModalCurrentObjectInfo()
            this.props.getObjectById([this.props.match.params.id])
        }
    }

    render() {
        const { height, isShowInTask } = this.props

        return (
            <div className="ObjectScreen">
                <div className="MainCard" style={{ minHeight: height - 100 }}>
                    <HeadBar />
                    <ListObjects isShowInTask={isShowInTask} />

                   
                    {this.props.objects.length === 0 && (
                        <Empty
                            description={<span>Không có dữ liệu</span>}
                        ></Empty>
                    )}

                    <Paginate />
                    <ModalExportObject/>
                    <ModalConfirmDelete />
                    <ModalObjectInfo />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
        objects: state.object.objects,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListObject: params => {
            dispatch(objectActions.action.loadListObject(params))
        },
        showModalCurrentObjectInfo: () => {
            dispatch(objectActions.action.showModalCurrentObjectInfo())
        },
        getObjectById: lst => {
            dispatch(objectActions.action.getObjectById(lst))
        },
        changeCurrentPage: pageNumber => {
            dispatch(objectActions.action.changeCurrentPage(pageNumber))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ObjectsScreen)
